export default __webpack_public_path__ + "static/media/ellie-roberts.30512c1f.jpeg";